'use client'

import { Builder } from '@builder.io/react'

import { MediaGallery } from './MediaGallery'
import { mediaGalleryDefaults } from './MediaGallery.defaults'

Builder.registerComponent(MediaGallery, {
  name: 'MediaGallery',
  noWrap: true,
  image: 'https://unpkg.com/@tabler/icons@2.44.0/icons/box-margin.svg',
  inputs: [
    {
      name: 'mediaItems',
      type: 'list',
      subFields: [
        {
          name: 'mediaType',
          type: 'string',
          enum: ['photo', 'video'],
          defaultValue: 'photo',
          helperText: 'Photo or video media.',
        },
        {
          name: 'desktopImgSrc',
          friendlyName: 'Desktop image',
          type: 'file',
          allowedFileTypes: ['jpeg', 'jpg', 'png', 'svg'],
          showIf: 'options.get("mediaType") === "photo"',
        },
        {
          name: 'mobileImgSrc',
          friendlyName: 'Mobile image',
          type: 'file',
          allowedFileTypes: ['jpeg', 'jpg', 'png', 'svg'],
          showIf: 'options.get("mediaType") === "photo"',
        },
        {
          name: 'brightcoveVideoId',
          type: 'string',
          defaultValue: '6359706013112',
          showIf: 'options.get("mediaType") === "video"',
        },
        {
          name: 'videoThumbnailImgSrc',
          friendlyName: 'Thumbnail image for Video',
          type: 'file',
          allowedFileTypes: ['jpeg', 'jpg', 'png', 'svg'],
          showIf: 'options.get("mediaType") === "video"',
        },
        {
          name: 'videoPlayerAspectRatio',
          type: 'string',
          enum: ['16 / 9', '9 / 16'],
          defaultValue: '16 / 9',
          showIf: 'options.get("mediaType") === "video"',
        },
      ],
      defaultValue: mediaGalleryDefaults.mediaItems,
    },
  ],
})
